const STORAGE_KEY = 'player-settings';

class PlayerSettings {
  set(key: string, value: string | boolean | number) {
    const settings = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    settings[key] = value;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  }

  get(key: string): string | boolean | number {
    const settings = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return settings?.[key];
  }
}

export default new PlayerSettings();
